enum SWAP_ASSET {
  LBTC = 'tL-BTC',
  USDT = 'tL-USDt',
}

export default SWAP_ASSET;
